import { useProfile } from "../profile";

export function useAccountType() {
  const { data } = useProfile();

  return {
    isBusinessAccount: data?.account_type === "business",
  };
}
